import React, { useMemo } from "react";
import { Grid, Typography } from "@material-ui/core";
import intl from "react-intl-universal";

import { IWithballData } from "types";
import { StatisticsBoard } from "components/StatisticsBoard";

import { calculatePecentage, groupWithBallByPosition } from "utils";

interface IMyDribblePanelProps {
  dataArray: IWithballData[];
}

export const MyDribblePanel = ({ dataArray }: IMyDribblePanelProps) => {
  const { summary } = useMemo(() => {
    return {
      summary: groupWithBallByPosition(dataArray),
    };
  }, [dataArray]);
  const succInSelf = summary.selfHalf.filter((dribble) => dribble.succeed)
    .length;
  const succInOther = summary.otherHalf.filter((dribble) => dribble.succeed)
    .length;
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Typography>{`${intl.get("STATS_POS_SELF")}`}</Typography>
          <Typography>{`${intl.get(
            "MATCH_TEAM_OVERVIEW_DRIBBLE_ATTEMPT_TOTAL"
          )}: ${summary.selfHalf.length}`}</Typography>
          <Typography>{`${intl.get(
            "MATCH_TEAM_OVERVIEW_DRIBBLE_SUCC"
          )}: ${succInSelf} (${calculatePecentage(
            succInSelf,
            summary.selfHalf.length
          )})`}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography>{`${intl.get("STATS_POS_OTHER")}`}</Typography>
          <Typography>{`${intl.get(
            "MATCH_TEAM_OVERVIEW_DRIBBLE_ATTEMPT_TOTAL"
          )}: ${summary.otherHalf.length}`}</Typography>
          <Typography>{`${intl.get(
            "MATCH_TEAM_OVERVIEW_DRIBBLE_SUCC"
          )}: ${succInOther} (${calculatePecentage(
            succInOther,
            summary.otherHalf.length
          )})`}</Typography>
        </Grid>
        <Grid item xs={4}>
          <StatisticsBoard data={dataArray} />
        </Grid>
      </Grid>
    </>
  );
};
